<template>
    <v-card style="height: 100%; max-height: 100%; overflow-y: auto" class="ma-0 pa-0" flat>
      <v-row class="ma-0 pa-0" style="width: 100%;" align="center">
          <v-col cols="auto">
            <span class="report-subtitle">ROAS vs Contribution</span>
          </v-col>
          <!-- <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn disabled icon>
              <v-icon color="black">mdi-cog</v-icon>
            </v-btn>
          </v-col> -->
          <v-col cols="12" class="ma-0 pa-0" style="height: 10px;">
            <v-divider class="mx-12"></v-divider>
          </v-col>
          <v-col cols="12" v-if="!graph_visible">
            <v-skeleton-loader
                      light
                      :style="{
                        height: screenHeight + 'px',
                      }"
                      type="image,image,image,image"
            ></v-skeleton-loader>
          </v-col>
          <v-col v-if="graph_visible" :cols="main_graph_section_cols" class="ma-0 pa-0" style="height: calc(100% - 10px);">
            <v-row class="ma-0 pa-0" style="height: 100%;">
                <v-col cols="12">
                  <div
                      :style="{
                        height: screenHeight + 'px',
                      }"
                    >   
                      <v-chart
                        class="performanceChart"
                        :option="graph_options"
                        :ref="chart_ref"
                        :id="chart_id"
                        autoresize
                      ></v-chart>
                  </div>
                </v-col>
              <!-- </v-col> -->
            </v-row>
          </v-col>
      </v-row>
          <v-spacer></v-spacer>
          <v-col cols="4" v-if="comments_section">
            <CommentSection v-on:close_comments="close_comments" :comments_persistent="comments_persistent"></CommentSection>
          </v-col>
    </v-card>
  </template>
  
  <script>  
  // Configs
  import columnChartConfig from "@/configs/Performance/performance_roi_contribution_overview_config.json";
  // import cpalette from "@/configs/ChartColors/get_color_palette.js";
  import CommentSection from "./comment_section.vue"
  import VChart, { THEME_KEY } from 'vue-echarts';
  import "echarts";
  import { use } from 'echarts/core';
  import { CanvasRenderer } from 'echarts/renderers'; 'echarts/charts';
  import {
      TitleComponent,
      TooltipComponent,
      LegendComponent,
  } from 'echarts/components';
  import {
    PERFORMANCE_AXIS_LABEL,
    PERFORMANCE_AXIS_LINE,
    PERFORMANCE_AXIS_NAME,
    PERFORMANCE_CHART_COLORS,
    PERFORMANCE_LEGEND_TEXT,
    PERFORMANCE_SPLIT_LINE,
  } from "./performanceChartStyle.js";

  use([
      CanvasRenderer,
      TitleComponent,
      TooltipComponent,
      LegendComponent,
  ]);

  
  export default {
    name: "ROASContribution",
    props: [
      'data_version',
      'dataset',
      'comments_persistent',
      'color_palette',
      'chart_ref',
      'chart_id',
      'chart_update_key'
    ],
    components: {
      VChart,
      CommentSection
    },
    provide: {
      [THEME_KEY]: 'light',
    },
    methods: {
      reload_graph: function () {
        this.graph_visible = false;
        setTimeout(() => (this.graph_visible = true), 10);
      }
    },
  
    data: () => ({
      graph_visible: false,
  
      graph_config: columnChartConfig,
      graph_data: null,

      comments_section: false,
      main_graph_section_cols: 12,
      minor_graph_section_cols: 12,
      screenHeight: window.innerHeight * 0.55,
      colors: [
        "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", 
        "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf", 
        "#aec7e8", "#ffbb78", "#98df8a", "#ff9896", "#c5b0d5", 
        "#c49c94", "#f7b6d2", "#c7c7c7", "#dbdb8d", "#9edae5", 
        "#7f7f7f", "#bcbd22", "#17becf", "#aec7e8", "#ffbb78", 
        "#98df8a", "#ff9896", "#c5b0d5", "#c49c94", "#f7b6d2", 
        "#c7c7c7", "#dbdb8d", "#9edae5", "#7f7f7f", "#bcbd22", 
        "#17becf", "#aec7e8", "#ffbb78", "#98df8a", "#ff9896", 
        "#c5b0d5", "#c49c94", "#f7b6d2", "#c7c7c7", "#dbdb8d", 
        "#9edae5", "#7f7f7f", "#bcbd22", "#17becf", "#aec7e8"
      ]
    }),
    mounted() {
      this.graph_data = this.dataset;
      if(this.dataset != null){
        this.reload_graph();
      }
    },
    watch: {
      dataset: {
        immediate: false,
        handler: function () {
          this.graph_data = this.dataset;
          if(this.dataset != null){
            this.reload_graph();
          }
        },
        deep: true,
      }
    },
    computed: {
      graph_options: function() {

        let dataset = this.graph_data['contribution']

        let data_category = []
        let data_series = []
        let data = []
        let series = []

        if(dataset != null){

            data = Array.from(Array(dataset[0].length - 2), () => []);
            data_series = dataset[0]
            data_series.shift();
            data_series = data_series.filter((header) => typeof(header) == 'string');

            for(let i = 1; i < dataset.length - 1; i++){
                data_category.push(dataset[i][0]);
                
                for(let j = 1; j < dataset[i].length - 1; j++) {
                  data[j-1].push(dataset[i][j])
                }
            }

            for(let idx = 0; idx < data.length; idx++) {
                series.push(
                    {
                        name: data_series[idx],
                        type: data_series[idx] == 'ROAS' ? 'scatter': 'bar',
                        symbolSize: data_series[idx] == 'ROAS' ? 22 : null,
                        showSymbol: false,
                        areaStyle: {},
                        data: data[idx],
                        yAxisIndex: data_series[idx] == 'ROAS' ? 1 : 0,
                        emphasis: {
                            focus: 'series'
                        },
                    }
                )
            }
        }

        const graph_option = {
            tooltip: {
              trigger: 'axis',
              backgroundColor: "rgba(15, 23, 42, 0.92)",
              borderWidth: 0,
              textStyle: {
                color: "#ffffff",
                fontFamily: "Poppins",
                fontSize: 13,
              },
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#475569'
                }
              }
            },
            color: [PERFORMANCE_CHART_COLORS[2], PERFORMANCE_CHART_COLORS[0], PERFORMANCE_CHART_COLORS[1]],
            legend: {
              data:data_series,
              type: "scroll",
              top: 0,
              itemHeight: 10,
              itemWidth: 18,
              textStyle: PERFORMANCE_LEGEND_TEXT
            },
            grid: {
                left: '4%',
                right: '5%',
                bottom: '6%',
                top: 44,
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: data_category,
                    axisLine: PERFORMANCE_AXIS_LINE,
                    axisTick: {
                        alignWithLabel: true,
                        lineStyle: {
                          color: "#cbd5e1"
                        }
                    },
                    axisLabel: PERFORMANCE_AXIS_LABEL
                }
            ],
            yAxis: [
                {
                  name: 'Spend/Contribution ($)',
                  nameTextStyle: PERFORMANCE_AXIS_NAME,
                  type: 'value',
                  alignTicks: true,
                  axisLine: PERFORMANCE_AXIS_LINE,
                  splitLine: PERFORMANCE_SPLIT_LINE,
                  axisLabel: {
                    ...PERFORMANCE_AXIS_LABEL,
                    formatter: function (value) {
                      if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
                      if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                      if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                      return '$' + value.toFixed(1);
                    }
                  }
                },
                {
                  name: 'ROAS($)',
                  nameTextStyle: PERFORMANCE_AXIS_NAME,
                  type: 'value',
                  alignTicks: true,
                  axisLine: PERFORMANCE_AXIS_LINE,
                  splitLine: { show: false },
                  axisLabel: {
                    ...PERFORMANCE_AXIS_LABEL,
                    formatter: function (value) {
                      if (value >= 1e9) return '$' + (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
                      if (value >= 1e6) return '$' + (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
                      if (value >= 1e3) return '$' + (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
                      return '$' + value.toFixed(1);
                    }                   
                  }
                }
            ],
            series: series,
            // color: COLOR_PALETTE
        }
        return graph_option
      },
    }
  };
  </script>
  
  <style scoped>
  .main-page-title {
    /* line-height: 5em; */
    font-family: "Poppins";
    font-weight: 600;
    font-size: 1.5em;
  }
  .report-subtitle {
    font-family: "Poppins";
    font-weight: 600;
    font-size: 1.05em;
    color: #1e293b;
  }
  
  .graph-title {
    font-family: "Poppins";
    font-weight: 300;
    font-size: 0.9em;
  }
  
  .report-version {
    font-family: "Poppins";
    font-weight: 600;
    align-items: center;
    /* font-size: 0.5em; */
    /* width: 50px; */
  }
  
  .performanceChart {
    height: 100%;
    width: 100%;
  }
  
  .chartHeader {
    .chartHeaderText {
      font-family: "Poppins" !important;
      font-weight: 600;
      font-size: 1.5em;
    }
  
    display: flex;
  }
  
  .toolBar {
    float: right;
  }
  
  .toolButton {
    padding: 0 32px;
    width: 50px;
    color: black;
  }
  
  ::v-deep .v-overlay__content {
    position: absolute;
    right: 0;
    height: 100%;
    width: 30%;
  }
  
  .overlayField {
    padding: 0 16px;
  }
  
  .overlayButton {
    float: right;
  }
  
  .chartWithOverlay {
    /* position: relative; */
    width: 100%;
    /* height: 500px; */
  }
  .miniChartWithOverlay {
    /* position: relative; */
    width: 100%;
    height: 75px;
  }
  
  .metricToggleOverlay {
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    top: 12%;
    left: 90px;
  }
  
  .metricToggleRow {
    margin-left: 0;
    margin-right: auto;
  }
  .metric_toolbar_title {
    font-weight: 800 !important;
  }
  .metric_toolbar_subtitle {
    font-weight: 600 !important;
  }
  .metric_toolbar_metric_title {
    line-height: 1em;
    font-weight: 200 !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    width: calc(80%);
    text-align: left;
    overflow: hidden;
  }
  
  .tooltip_description {
    font-family: "Poppins" !important;
    font-weight: 200;
  }
  .long_description {
    font-family: "Poppins" !important;
  }
  
  .expansionPanel {
    overflow: none;
  }
  
  .reportCommentContent {
    max-height: 350px;
    overflow-y: auto;
  }
  
  .reportCommentInputField {
    float: right;
    width: 90%;
  }
  </style>
  
